<template>
    <div class="MagentoOrder">
        <div class="MagentoOrderTableHeader MagentoOrderHeader" @click="ToggleDetails">
            <div>{{ OrderData.increment_id }}</div>
            <div>{{ OrderData.store_name }}</div>
            <div :class="{Payment_Processing:OrderData.status==='processing', Payment_Canceled:OrderData.status==='canceled', Payment_Complete:OrderData.status==='complete'}">{{ OrderData.status }}</div>
            <div>{{ $FormatCurrency(OrderData.grand_total, OrderData.order_currency_code) }}</div>
            <div>{{ OrderDate }}</div>
        </div>
        <div :class="{MagentoOrderDetails:true, MagentoOrderDetailsOpen:ShowDetails}">
            <div>出荷経費（税除外）: {{ $FormatCurrency(OrderData.shipping_amount, OrderData.order_currency_code) }}</div>
            <div>出荷経費 税 {{ $FormatCurrency(OrderData.shipping_tax_amount, OrderData.order_currency_code) }} }}</div>
            <div>出荷経費: {{ $FormatCurrency(OrderData.shipping_incl_tax, OrderData.order_currency_code) }}</div>
            <div>値段（税除外）{{ $FormatCurrency(OrderData.subtotal, OrderData.order_currency_code) }} }}</div>
            <div>値段 税 {{ $FormatCurrency(OrderData.tax_amount, OrderData.order_currency_code) }} }}</div>
            <div>値段 {{ $FormatCurrency(OrderData.subtotal_incl_tax, OrderData.order_currency_code) }} }}</div>
            <div>合計 {{ $FormatCurrency(OrderData.grand_total, OrderData.order_currency_code) }} </div>
            <div></div>
            <div>商品数 {{ OrderData.total_qty_ordered }}</div>
        </div>
    </div>
</template>

<script>
export default{
    props: {
        OrderData:Object,
    },
    computed:{
        OrderDate()
        {
            const d = new Date(this.OrderData.created_at);
            return `${d.getFullYear()}/${d.getMonth()+1}/${d.getDate()}`;
        },
    },
    methods:
    {
        ToggleDetails(){
            this.ShowDetails = !this.ShowDetails;
        }
    },
    data(){
        return{
            ShowDetails: false
        }
    },
}
</script>

<style>
.MagentoOrder
{
    border: 1px solid gray;
}

.MagentoOrderDetails
{
    transition: 0.4s;
    -webkit-transition: 0.4s;
    -moz-transition: 0.4s;
    max-height: 0px;
    overflow: hidden;
    opacity: 0;
    padding: 0px 10px;
    background-color: rgb(173, 173, 173);
}

.MagentoOrderDetailsOpen
{
    max-height: 500px;
    opacity: 1;
    padding: 4px 10px;
}

.MagentoOrderHeader
{
    background-color: rgb(105, 102, 97) !important;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
    font-weight: normal !important;
    font-size: 0.8rem !important;
}

.MagentoOrderHeader:hover
{
    background-color: rgb(145, 142, 137) !important;
}

.Payment_Processing
{
    color: rgb(138, 159, 252);
}

.Payment_Canceled
{
    color: orange;
}

.Payment_Complete
{
    color: rgb(94, 201, 62);
}
</style>